export const housekeepingDrawer = {
  close: "Fechar",
  guest: "Hóspede",

  cleaning: {
    title: "Status da limpeza",
    lastCleaned: "Limpo em {date}",
    evidenceAlt: "evidência",
  },

  status: {
    dirty: "A limpar",
    in_progress: "Em andamento",
    clean: "Limpo",
    inspected: "Inspecionado",
    out_of_service: "Fora de serviço",
  },

  occupancy: {
    title: "Ocupação",
    aboutToLeave: "Prestes a sair",
    checkIn: "Check-in {date}",
    checkOut: "Check-out {date}",
    checkoutTime: "Check-out {time}",
    booking: "Reserva {code}",
    nextArrivalToday: "Próxima chegada hoje",
    fromTime: "a partir das {time}",
    labels: {
      vacant: "Vago",
      occupied: "Ocupado",
      departure_today: "Sai hoje",
      arrival_today: "Chega hoje",
      turnover: "Saída e chegada hoje",
    },
  },

  window: {
    windowLabel: "Janela",
    standardSchedule: "Horário padrão",
    sub: "{label}: check-out {checkout} → check-in {checkin}",
    overdue: "Chegada atrasada · priorize esta limpeza",
    untilArrival: "{dur} até a chegada",
  },

  tasks: {
    title: "Tarefas de limpeza",
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of open tasks
    pendingCount: "{count} pendente | {count} pendentes",
    newPlaceholder: "Adicione uma tarefa (ex.: Trocar as toalhas)",
    priorityTitle: "Prioridade",
    dateTitle: "Data",
    timeTitle: "Horário (opcional)",
    assignTitle: "Atribuir a",
    assignAllOption: "Todos (limpeza e manutenção)",
    byRole: "Por função",
    wholeRoleSuffix: "(função inteira)",
    people: "Pessoas",
    add: "Adicionar",
    adding: "Adicionando…",
    loading: "Carregando tarefas…",
    empty: "Nenhuma tarefa. Adicione a primeira acima.",
    markPending: "Marcar como pendente",
    markDone: "Marcar como concluída",
    priorityDotTitle: "Prioridade {priority}",
    delete: "Excluir",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "Baixa",
    normal: "Normal",
    high: "Alta",
    urgent: "Urgente",
  },

  roles: {
    limpieza: "Limpeza",
    mantenimiento: "Manutenção",
    propietario: "Proprietário",
  },

  assignee: {
    assigned: "Atribuída",
    all: "Todos",
  },
};
